<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Flag Off" class="d-icon d-icon--flag-off" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`" fill-rule="evenodd" clip-rule="evenodd" fill="currentColor"><path d="M3.5 1A.5.5 0 0 1 4 .5c.847 0 1.548.28 2.158.525l.028.01C6.82 1.29 7.36 1.5 8 1.5c.694 0 1.13-.115 1.377-.214a1.341 1.341 0 0 0 .28-.15.5.5 0 0 1 .843.364V7a.5.5 0 0 1-1 0V2.302c-.364.112-.854.198-1.5.198-.847 0-1.548-.28-2.158-.525l-.028-.01C5.18 1.71 4.64 1.5 4 1.5a.5.5 0 0 1-.5-.5ZM1.354.646a.5.5 0 1 0-.708.708l.854.853V11a.5.5 0 0 0 1 0V7.769c.035-.017.076-.036.123-.055C2.87 7.615 3.306 7.5 4 7.5c.64 0 1.18.21 1.814.464l.028.011c.558.224 1.193.477 1.945.52l2.86 2.859a.5.5 0 0 0 .707-.708l-10-10ZM4 6.5c.847 0 1.548.28 2.158.525l.028.01.237.095L2.5 3.207v3.491c.364-.112.854-.198 1.5-.198Z"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconFlagOff',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
